package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.silk.components.overlay.Tooltip

@Composable
internal fun WithTooltip(
    tooltipText: String,
    content: @Composable () -> Unit,
) {
    Box(contentAlignment = Alignment.Center) {
        content()
        Tooltip(
            target = ElementTarget.PreviousSibling,
            text = tooltipText,
        )
    }
}
